export default "__VITE_ASSET__70257d1c__"